export default __webpack_public_path__ + "static/media/diya1.cc25ee76.jpg";